module.exports = __webpack_public_path__ + "img/i-community.fa0a0dd5.svg";